export default {
    duration: 120,
    correctScore: 3,
};
